<template>
  <div class="home">
    <quick-search :search="search" :value="query" :loading="searchingCount || loadingPosts" :count="searchCount" :queryChanged="searchQueryChanged"/>
    <br />
    <br />
    <div class="container" v-if="loadingPosts">
      <font-awesome-icon class="spinner" size="2x" icon="circle-notch" :spin="true"/>
    </div>
    <div class="container" v-else-if="items.length > 0">
      <post v-for="item in items" v-bind:key="item._id" :post="item" style="margin: 5px"/>
      <br />
      <br />
      <b-pagination align="center" size="md" :total-rows="total" v-model="currentPage" :per-page="itemsPerPage" @change="pageClicked">
      </b-pagination>
      <br />
    </div>
    <div class="container" v-else>
      <b-alert show variant="danger" v-if="statusOk === false && errMessage">{{errMessage}}</b-alert>
      <strong class="no-result" v-else-if="statusOk">{{langHomePage.noPostFound[locale]}}</strong>
      <div class="may-be-an-ad" v-else/>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// @ is an alias to /src
import NettipyoraButton from '@/components/NettipyoraButton';
import QuickSearch from '@/components/QuickSearch';
import Post from '@/components/Post';
import { mapState } from 'vuex';
import langHomePage from '@/store/lang/homePage';

export default {
  name: 'home',
  components: {
    QuickSearch, Post, NettipyoraButton
  },
  data() {
    return {
      langHomePage,
      query: {},
      currentPage: 1
    }
  },
  computed: mapState({
    locale: state => state.locale,
    loadingPosts: state => state.Home.loadingPosts,
    statusOk: state => state.Home.statusOk,
    errMessage: state => state.Home.errMessage,
    okMessage: state => state.Home.okMessage,
    searchingCount: state => state.Home.searchingCount,
    searchCount: state => state.Home.searchCount,
    items: state => state.Home.items,
    total: state => state.Home.total,
    itemsPerPage: state => state.Home.itemsPerPage,
    page: state => state.Home.page
  }),
  created() {
    this.query = {
      types: this.$route.query.types ? this.$route.query.types : null,
      subTypes: this.$route.query.subTypes ? this.$route.query.subTypes : null,
      provinces: this.$route.query.provinces ? this.$route.query.provinces : null,
      cities: this.$route.query.cities ? this.$route.query.cities : null,
      minPrice: +this.$route.query.minPrice >= 0 ? +this.$route.query.minPrice : undefined,
      maxPrice: +this.$route.query.maxPrice >= 0 ? +this.$route.query.maxPrice : undefined,
      condition:  this.$route.query.condition ? this.$route.query.condition : null
    };

    const query = JSON.parse(JSON.stringify(this.query));
    query.searchType = "count";

    if(+this.$route.query.page > 0) {
      this.currentPage = +this.$route.query.page;
      this.search(JSON.parse(JSON.stringify(this.query)));
    } else this.currentPage = 1;

    this.$store.dispatch('HOME_FETCH_COUNT', query)
  },
  methods: {
    search(query) {
      //get query
      this.query = query;
      query.page = this.currentPage;
      this.$router.replace({query: query});
      this.$store.dispatch('HOME_FETCH_POSTS', query);
    },
    searchQueryChanged(query) {
      console.log('this', this.query);
      console.log('changed', query);
      this.$store.dispatch('HOME_FETCH_COUNT', query)
    },
    pageClicked(newPageNum) {
      const query = JSON.parse(JSON.stringify(this.query));
      query.page = this.currentPage = newPageNum;
      this.$router.replace({query: query});
      this.$store.dispatch('HOME_FETCH_POSTS', query);
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  margin: 1em;

  .spinner, .no-result {
    margin: 2em;
  }
}
</style>

